import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiHolder, apis } from 'api';
const aiAsstWmApi = apiHolder.api.requireLogicalApi(apis.aiAsstWmApiImpl);
const initialState = {
    defaultConfig: {
        enableDeepThinking: false,
        hasAiSearchAbility: false,
    },
    defaultConfigFetching: false,
};
export const getDefaultConfigAsync = createAsyncThunk('ai-asst-wm/getDefaultConfigAsync', async () => {
    return await aiAsstWmApi.aiAsstDefaultConfig();
});
const aiAsstWmSlice = createSlice({
    name: 'aiAsstWmReducer',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(getDefaultConfigAsync.pending, state => {
            state.defaultConfigFetching = true;
        });
        builder.addCase(getDefaultConfigAsync.fulfilled, (state, action) => {
            state.defaultConfig = action.payload;
            state.defaultConfigFetching = false;
        });
        builder.addCase(getDefaultConfigAsync.rejected, state => {
            state.defaultConfigFetching = false;
        });
    },
});
export const { actions } = aiAsstWmSlice;
export default aiAsstWmSlice.reducer;
